/**
 * @Author: Zewei
 * @Date:   2018-01-19T12:17:28+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-28T13:27:06+08:00
 */
 import React, { PureComponent } from 'react';
 import { Layout, Menu, Icon, Spin, Tag, Dropdown, Divider } from 'antd';
 import moment from 'moment';
 import groupBy from 'lodash/groupBy';
 import Debounce from 'lodash-decorators/debounce';
 import { Link } from 'react-router-dom';
 // import NoticeIcon from '../NoticeIcon';
 // import HeaderSearch from '../HeaderSearch';
 import './index.less';

 const { Header } = Layout;

 class GlobalHeader extends PureComponent {
   componentWillUnmount() {
     this.triggerResizeEvent.cancel();
   }
   getNoticeData() {
     const { notices = [] } = this.props;
     if (notices.length === 0) {
       return {};
     }
     const newNotices = notices.map((notice) => {
       const newNotice = { ...notice };
       if (newNotice.datetime) {
         newNotice.datetime = moment(notice.datetime).fromNow();
       }
       // transform id to item key
       if (newNotice.id) {
         newNotice.key = newNotice.id;
       }
       if (newNotice.extra && newNotice.status) {
         const color = ({
           todo: '',
           processing: 'blue',
           urgent: 'red',
           doing: 'gold',
         })[newNotice.status];
         newNotice.extra = <Tag color={color} style={{ marginRight: 0 }}>{newNotice.extra}</Tag>;
       }
       return newNotice;
     });
     return groupBy(newNotices, 'type');
   }

   toggle = () => {
     const { collapsed, onCollapse } = this.props;
     onCollapse(!collapsed);
     this.triggerResizeEvent();
   }
   @Debounce(600)
   triggerResizeEvent() { // eslint-disable-line
     const event = document.createEvent('HTMLEvents');
     event.initEvent('resize', true, false);
     window.dispatchEvent(event);
   }

   render() {
     const {
       /*collapsed, */ isMobile, logo, onMenuClick, currentUser,
     } = this.props;

     const menu = (
       <Menu className="menu" selectedKeys={[]} onClick={onMenuClick}>
         <Menu.Item disabled><Icon type="user" />个人中心</Menu.Item>
         <Menu.Item disabled><Icon type="setting" />设置</Menu.Item>
         <Menu.Item key="change_password"><Icon type="lock" />更改密码</Menu.Item>
         {currentUser.UserName === 'Lisa.yang' && (
           <Menu.Item key="change_second_password"><Icon type="lock" />更改二级密码</Menu.Item>
         )}
         <Menu.Divider />
         <Menu.Item key="logout">
            <Icon type="logout" />退出登录
         </Menu.Item>
       </Menu>
     );
     // const noticeData = this.getNoticeData();
     return (
       <Header className="header">
         {isMobile && (
           [
             (
               <Link to="/" className="logo" key="logo">
                 <img src={logo} alt="logo" width="32" />
               </Link>
             ),
             <Divider type="vertical" key="line" />,
           ]
         )}
         {/*
            <Icon
               className="trigger"
               type={collapsed ? 'menu-unfold' : 'menu-fold'}
               onClick={this.toggle}
             />
         */}
         <div className="right">
           {/*
               <HeaderSearch
                 className={`${styles.action} ${styles.search}`}
                 placeholder="站内搜索"
                 dataSource={['搜索提示一', '搜索提示二', '搜索提示三']}
                 onSearch={(value) => {
                   console.log('input', value); // eslint-disable-line
                 }}
                 onPressEnter={(value) => {
                   console.log('enter', value); // eslint-disable-line
                 }}
               />
           */}
           {/*
               <NoticeIcon
                 className="action"
                 count={currentUser.notifyCount}
                 onItemClick={(item, tabProps) => {
                   console.log(item, tabProps); // eslint-disable-line
                 }}
                 onClear={onNoticeClear}
                 onPopupVisibleChange={onNoticeVisibleChange}
                 loading={fetchingNotices}
                 popupAlign={{ offset: [20, -16] }}
               >
                 <NoticeIcon.Tab
                   list={noticeData['通知']}
                   title="通知"
                   emptyText="你已查看所有通知"
                   emptyImage='../../assets/images/empty.svg'
                 />
                 <NoticeIcon.Tab
                   list={noticeData['消息']}
                   title="消息"
                   emptyText="您已读完所有消息"
                   emptyImage='../../assets/images/empty.svg'
                 />
                 <NoticeIcon.Tab
                   list={noticeData['待办']}
                   title="待办"
                   emptyText="你已完成所有待办"
                   emptyImage='../../assets/images/empty.svg'
                 />
               </NoticeIcon>
           */}
           {
               currentUser.UserName ?
               (
                 <Dropdown overlay={menu}>
                   <span className="action account">
                     {/* <Avatar size="small" className="avatar" src={userAvatar} /> */}
                     <span className="name">{currentUser.UserName}</span>
                   </span>
                 </Dropdown>
               )
               :
               <Spin size="small" style={{ marginLeft: 8 }} />
          }
         </div>
       </Header>
     );
   }
 }

export default GlobalHeader;



// WEBPACK FOOTER //
// ./src/components/GlobalHeader/index.js